Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.maybeBuild = maybeBuild;
var mockTargetValues = {
    targetOriginX: 0,
    targetOriginY: 0,
    targetWidth: 0,
    targetHeight: 0,
    targetGlobalOriginX: 0,
    targetGlobalOriginY: 0,
    targetBorderRadius: 0,
    windowWidth: 0,
    windowHeight: 0,
    currentOriginX: 0,
    currentOriginY: 0,
    currentWidth: 0,
    currentHeight: 0,
    currentGlobalOriginX: 0,
    currentGlobalOriginY: 0,
    currentBorderRadius: 0
};
function maybeBuild(layoutAnimationOrBuilder, style, displayName) {
    var isAnimationBuilder = function isAnimationBuilder(value) {
        return "build" in layoutAnimationOrBuilder && typeof layoutAnimationOrBuilder.build === "function";
    };
    if (isAnimationBuilder(layoutAnimationOrBuilder)) {
        var animationFactory = layoutAnimationOrBuilder.build();
        var layoutAnimation = animationFactory(mockTargetValues);
        var animatedStyle = layoutAnimation.animations;
        var getCommonProperties = function getCommonProperties(obj1, obj2) {
            return Object.keys(obj1).filter(function(key) {
                return Object.prototype.hasOwnProperty.call(obj2, key);
            });
        };
        var commonProperties = getCommonProperties(animatedStyle, style || {});
        if (commonProperties.length > 0) {
            console.warn("[Reanimated] ".concat(commonProperties.length === 1 ? "Property" : "Properties: ", ' "').concat(commonProperties, '" of ').concat(displayName, " may be overwritten with layout animation. Please create a wrapper with the layout animation you want to apply."));
        }
        return layoutAnimationOrBuilder.build();
    } else {
        return layoutAnimationOrBuilder;
    }
}
